export class NavState {
  /**
   * @var {AppNavItem[]}
   */
  appNavItems;

  /**
   * @var {boolean}
   */
  currentRouteNeedsExactMatch = false;

  /**
   *
   * @type {Object}
   */
  allSubItems = {};

  /**
   * @type {{}}
   */
  contextNavOptions = {};

  /**
   * Context Nav
   *
   * @var {boolean}
   */
  showFilterButton = false;

  /**
   * @type {Object}
   */
  filterContextNavOptions = {};

  /**
   * @type {?string}
   */
  currentAppNavItemKey = null;

  /**
   * Context Nav
   *
   * @var {boolean}
   */
  showCommentButton = false;

  /**
   * Context Nav
   *
   * @var {boolean}
   */
  showActivityLogButton = false;

  /**
   * Context Nav
   *
   * @var {boolean}
   */
  showAssistantButton = false;

  /**
   * @var {string|null}
   * The tooltip text for the contextual input.
   * If null, no tooltip will be shown.
   */
  contextualInputTooltipText = null;

  /**
   * @var {boolean}
   * If true, the contextual input will be disabled.
   */
  disableContextualInput = false;

  /**
   * @var {boolean}
   * If true, the contextual input tooltip will be used as the submit button tooltip.
   * If false, the submit button will have its own tooltip.
   */
  setUseContextualInputTooltipAsSubmitButtonTooltip = false;

  /**
   * Context Nav
   * Example: {component: 'Dashboard', showContextualInput: true, submitButtonText: 'Submit', footerText: 'Footer text', placeholderText: 'Placeholder text'}
   *
   * @var {object}
   */
  assistantComponentConfig = {};

  /**
   * Context Nav
   *
   * @var {array}
   */
  showFileButton = [];

  /**
   * Context Nav
   *
   * @type {object}
   */
  isShowingFilesModal = {};

  /**
   * @type {?string}
   */
  isShowingActivityOrCommentsOrFilePanel = null;
}
